import React, { Component } from 'react';
import { HashRouter, Route } from 'react-router-dom';
import Main from './pages/Main';

class App extends Component {
    render() {
        return (
            <HashRouter>
                <Route exact path='/' render={() => <Main />} />
            </HashRouter>
        );
    }
}

export default App;
